import React, {useContext} from 'react';
import {TableDataContext} from '../../../Contexts/TableDataContext'
import ToCompanies from './ToCompanies';
import ToAcquirers from './ToAcquirers';
import MostActiveAdvisor from './MostActiveAdvisor';
import MostActiveAdvisorsCount from './MostActiveAdvisorsCount';

/**
 * The `Card` component renders four different cards based on the data and loading status received from
 * the `TableDataContext`.
 * @returns The Card component is returning a JSX element.
 */
 const Card = () => {
  const { data, isLoad, isDataLoad ,menu ,props} = useContext(TableDataContext);

  return (
    <div className="">
      <div className='sm:full mt-[4.25rem] md:mt-[3rem] h-full  bg-[#F2F2F2]'>
        <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden scrollbar-remove" style={{scrollbarWidth: 'none'}}>
          <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:py-[0.7rem] md:min-w-max lg:contents">
           {/* ----card1----- */}
           <ToCompanies data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>
          {/* ----card2----- */}
          <ToAcquirers data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>          
          {/* ----card3----- */}
          <MostActiveAdvisor menu={props?.menu} data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>          
          {/* ----card4----- */}
          <MostActiveAdvisorsCount menu={props?.menu} data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>
          </div>
            </div>
        <div className='border-b-2 border-[#e5e5e5]'></div>
      </div >
    </div >
  )
}

export default Card;
